<CDBFooter class="shadow">
    <div class="d-flex flex-column mx-auto pt-5 footer-container">
        <div class="mx-auto footer-content">
            <div class="d-flex justify-content-between flex-wrap footer-links">
                <div class="logo align-self-center d-flex flex-column align-items-center logo-container">
                    <CDBLink class="d-flex align-items-center p-0 text-dark">
                        <img alt="logo" src="/assets/images/Jotto-empowring-ideas-purple.png" width="200px" />
                    </CDBLink>
                    <div class="flex justify-center w-full mt-1"> 
                        <div *ngFor="let social of socialMedia; let i = index" class="social-link w-[21px] h-[21px] text-2xl cursor-pointer mx-3 mb-4" (click)="openLink(social.link)" style="color: #491176"> 
                            <i [ngClass]="social.icon"></i>
                        </div>
                        <!-- <div *ngFor="let social of socialMedia; let i = index" class="social-link w-[21px] h-[21px] text-2xl cursor-pointer mx-3 mb-4" (click)="openLink(social.link)" style="color: #491176"> 
                            <i *ngIf="!social.imageUrl" [ngClass]="social.icon"></i>
                            <img *ngIf="social.imageUrl" [src]="social.imageUrl" alt="" width="20" class="social-link-image" />
                        </div> -->
                        <!-- This is for when the jotto icon is put back -->
                    </div>
                </div>
                
                <div class="footer-section">
                    <p class="h5 mb-2" style="font-weight: 600">About</p>
                    <ul class="footer-list mb-3">
                        <li class="my-1"> <button (click)="navigateToCompany()">Company</button></li>
                        <li class="my-1"><button  (click)="navigateToSupport()">Support</button></li>
                        <li class="my-1"><a  href="https://staging-app.jotto.me/policies/privacy">Privacy Policy</a></li>
                    </ul>
                </div>
                <div class="footer-section">
                    <p class="h5 mb-2" style="font-weight: 600">Visit</p>
                    <ul class="footer-list">
                        <li class="my-1">
                            <a href="/" disabled="disabled">
                                <div style="line-height: 32px;">417 5th Avenue</div>
                                <div style="line-height: 32px;">Suite 814</div>
                                <div style="line-height: 32px;">New York, NY 10016</div>
                            </a>
                        </li>
                    </ul>
                </div>
                
                <div class="footer-section">
                    <p class="h5 mb-2" style="font-weight: 600">Contact</p>
                    <ul class="footer-list">
                        <li class="my-1"><a  href="mailto:connect@jotto.video?subject=Contact%20Us%20">connect@jotto.me</a></li>
                        <li class="my-1"><a  href="tel:(718)388-5063">(718) 388-5063</a></li>
                    </ul>
                </div>
            </div>
            <div class="mt-5 w-full flex justify-between items-center flex-col border-t border-t-gray-600 footer-bottom pb-10">
                <p class="font-normal text-[14px] text-left leading-[27px]" style="color: #491176; text-align: center;">&copy; 2024 Jotto, Inc., All rights reserved.</p>
            </div>
        </div>
    </div>
</CDBFooter>
